<template>
  <div class="DrawerView">
		<ul class="uls">
			<li>
				<i>任务名称</i>
				<b>{{taskReport.title}}</b>
			</li>
			<li>
				<i>时间范围</i>
				<b>{{taskReport.start_time}} —— {{taskReport.end_time}}</b>
			</li>
			<li>
				<i>分发范围</i>
				<a-tooltip placement="left">
					<template slot="title">
						<span v-html="gradeRange">{{gradeRange}}</span>
					</template>
					<a-icon type="eye" theme="filled" />
				</a-tooltip>
			</li>
			<li>
				<i>包含量表</i>
				<a-tooltip placement="left">
					<template slot="title">
						<span v-html="scaleLists">{{scaleLists}}</span>
					</template>
					<a-icon type="eye" theme="filled" />
				</a-tooltip>
			</li>
		</ul>
		<div class="reportView">
      <div>
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="校级报告" key="1"><school-report/></a-tab-pane>
          <a-tab-pane tab="年级报告" key="2"><grade-report/></a-tab-pane>
          <a-tab-pane tab="班级报告" key="3"><class-report/></a-tab-pane>
          <a-tab-pane tab="个体报告" key="4"><personal-report/></a-tab-pane>
        </a-tabs>
      </div>
    </div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import SchoolReport from './SchoolReport'
  import GradeReport from './GradeReport'
  import ClassReport from './ClassReport'
	import PersonalReport from './PersonalReport'
	import GRADENEW from '@/util/gradeNew'
	export default {
		name: 'DrawerView',
		data () {
			return {
				scaleLists: [],
				gradeRange: []
			}
		},
		computed: {
			...mapState([
				'taskReport'
			])
		},
		components: {
			SchoolReport,
      GradeReport,
      ClassReport,
      PersonalReport
		},
		mounted () {
			let listOne = []
			let listTwo = []
			if (this.taskReport.type) { // 单校
				this.taskReport.scaleList.map(item => {
					listOne.push(item.SURVEY_TITLE)
				})
				this.taskReport.classAgg.map((item) => {
					listTwo.push(`${GRADENEW(item.entryYear).tableGrade}${item.classId}班`)
				})
			} else { // 0 教育局
				this.taskReport.SURVEY_LIST.map(item => {
					listOne.push(item.TITLE)
				})
				this.taskReport.GRADE_LIST.split(',').map(item => {
					listTwo.push(GRADENEW(item).tableGrade)
				})
			}
			this.scaleLists = listOne.join('</br>')
			this.gradeRange = listTwo.join('</br>')
		}
	}
</script>

<style>
	.DrawerView .uls {
		display: flex;
		justify-content: space-between;
		padding: 32px 40PX 25px;
		box-sizing: border-box;
		margin-bottom: 0px;
		font-size: 14px;
	}
	.DrawerView .uls li {
		display: flex;
		flex-direction: column;
		height: 65px;
		justify-content: space-between;
	}
	.DrawerView .uls li:first-child {
		flex-basis: 55%;
	}
	.DrawerView .uls li:nth-child(2) {
		flex-basis: 20%;
	}
	.DrawerView .uls li:first-child b {
		font-size: 24px;
	}
	.DrawerView .uls li i {
		font-style: normal;
		color: #8C8C8C;
	}
	.DrawerView .ant-tabs-nav {
		margin-left: 40px;
	}
	.DrawerView .ant-tabs-nav .ant-tabs-tab {
		padding: 15px 0px!important;
	}
	.DrawerView .ant-tabs-ink-bar {
		width: 56px!important;
	}
	.DrawerView  .ant-tabs-bar {
		margin-bottom: 0px!important;
	}
</style>